import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';
import { MensagemChamado } from 'src/app/admihair/api/dto/mensagem-chamado';
import { ArquivoAnexo } from 'src/app/admihair/api/file/arquivo-anexo';
import { AdmihairBaseComponent } from 'src/app/admihair/components/admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { MensagemChamadoService } from 'src/app/admihair/service/mensagem-chamado.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-base-conhecimento-detalhar',
  templateUrl: './base-conhecimento-detalhar.component.html',
  styleUrls: ['./base-conhecimento-detalhar.component.scss']
})
export class BaseConhecimentoDetalharComponent extends AdmihairBaseComponent implements OnInit {

  mensagem?: MensagemChamado;
  descricaoProblema?: string;
  descricaoSolucao?: string;
  listaEvidenciasAbertura: MensagemChamado[] = [];
  listaEvidenciasFechamento: MensagemChamado[] = [];


  constructor(
      private mensagemChamadoService: MensagemChamadoService,
      erroService: ErroService,
      storageService: UtilStorageService,
      router?: Router,
      activatedRoute?: ActivatedRoute) {
      super(erroService, storageService, router, activatedRoute)
    }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.buscarMensagemChamado();
  }

  buscarMensagemChamado() {
    this.mensagemChamadoService.listarBaseConhecimentoPorChamadoId(this.idParametroUrl).subscribe({
      next: (data: MensagemChamado[]) => {
        this.processarMensagemChamado(data);
        this.setExibirSpinnerPrincipal(false);
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    });
  }	

  processarMensagemChamado(lista: MensagemChamado[]) {
    if (lista.length === 0) {
      this.messagemVisivel = true;
      this.messages = [{severity: 'warn', summary: 'Atenção', detail: 'Dados não encontrados'}];
    } else {
      for (const item of lista) {
        if (item.categoria === 'ABERTURA' && item.tipoMensagem === 'TEXTO') {
          this.descricaoProblema = item.conteudo;
        }
  
        if (item.categoria === 'FECHAMENTO' && item.tipoMensagem === 'TEXTO') {
          this.descricaoSolucao = item.conteudo;
        }
        if (item.categoria === 'ABERTURA' && item.tipoMensagem !== 'TEXTO') {
          this.listaEvidenciasAbertura.push(item);
        }
        if (item.categoria === 'FECHAMENTO' && item.tipoMensagem !== 'TEXTO') {
          this.listaEvidenciasFechamento.push(item);
        }
      }

    }

  }

  abrirImagem(imagemBase64?: string) {
    if (imagemBase64) {
      const novaJanela = window.open();
      if (novaJanela) {
        novaJanela.document.write(`
          <html>
            <head><title>Visualizar Imagem</title></head>
            <body style="margin:0">
              <img src="${imagemBase64}" style="width:auto; height:auto; display:block;"/>
            </body>
          </html>
        `);
      }
    }
  }

  obterMimeTypeBase64(base64: string): string {
    const result = /^data:(.*?);base64,/.exec(base64);
    return result ? result[1] : 'application/octet-stream';
  }

  baixarArquivo(base64?: string, nomeArquivo?: string) {
    if (!base64 || !nomeArquivo) {
      console.error('Base64 ou nome do arquivo não fornecidos.');
      return;
    }
    const mimeType = this.obterMimeTypeBase64(base64);
    const byteCharacters = atob(base64.split(',')[1]);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = nomeArquivo;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  obterIconeArquivo(tipo?: string) {
    switch (tipo) {
      case 'IMAGEM':
        return 'pi pi-image';
      case 'PDF':
        return 'pi pi-file-pdf';
      case 'CSV':
        return 'pi pi-file-excel';
      case 'DOCX':
        return 'pi pi-file';
      default:
        return 'pi pi-file';
    }
  }

}
